import { render } from "./CaseClusterConnections.vue?vue&type=template&id=56abb1fa&ts=true"
import script from "./CaseClusterConnections.vue?vue&type=script&lang=ts"
export * from "./CaseClusterConnections.vue?vue&type=script&lang=ts"

import "./CaseClusterConnections.vue?vue&type=style&index=0&id=56abb1fa&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__